import { addToasterActionData } from "hooks/useToasterFromActionData";
import scraperApi from "api";
import { ActiveSubscriptionDataRouteType } from "routes/data-routes/billing-data/active-subscription/route.meta";


export const removeScheduledChangesAction: NonNullable<ActiveSubscriptionDataRouteType["route"]["action"]> = async () => {
  try {
    const activeSubscription = await scraperApi.subscription.removeScheduledChanges();
    return addToasterActionData(
      { activeSubscription },
      {
        toastId: "cancel-scheduled-change-success",
        type: "success",
        title: "Scheduled Change Cancelled",
        description: "Your scheduled plan change has been cancelled."
      }
    );
  } catch (error) {
    return addToasterActionData(
      {
        error: {
          taggedMessage: {
            message: "There was an error processing your request. Please try again later or [contact our support team|contact_support]"
          }
        }
      },
      {
        toastId: "cancel-scheduled-change-error",
        type: "error",
        title: "Error",
        description: "Failed to cancel the scheduled change. Please try again."
      }
    );
  }
};
